"use client";
import {createContext, ReactNode, useContext, useState} from "react";

interface OnboardContextProps {
    processStep: number | null;
    setProcessStep: React.Dispatch<React.SetStateAction<number | null>>;
}

const OnboardContext = createContext<OnboardContextProps | undefined>(undefined);

export const OnboardContextProvider = ({children}: {children: ReactNode}) => {
    const [processStep, setProcessStep] = useState<number | null>(null);

    return (
        <OnboardContext.Provider value={{
            processStep,
            setProcessStep
        }}>
            {children}
        </OnboardContext.Provider>
    )
}

export const useOnboardContext = () => {
    const context = useContext(OnboardContext);
    if (!context){
        throw new Error("useOnboardContext must be used within OnboardProvider");
    }
    return context;
}